import { CButton, Dialog } from '@/shared/ui'
import style from './index.module.scss'
import { CInput } from '@/shared/ui/cabinet'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import { setDialogs, updateSubAccountWallet } from '@/store/sub_accounts'
import { useAppDispatch } from '@/store'
import {
    EDIT_WALLET,
    editCommissionUser,
    ISubAccountInfoDto,
    useSubAccount,
} from '@/entities/cabinet'
import { toast } from 'react-toastify'
import { useEffect } from 'react'

const WalletScheme = Yup.object().shape({
    commission: Yup.string().required('Required'),
})

export function EditWalletAlert({
    commission,
    reqId,
    changeWallet,
}: {
    commission: any
    reqId: any
    changeWallet: (commission: any) => void
}) {
    const dispatch = useAppDispatch()
    const formik = useFormik({
        initialValues: { commission: commission },
        validationSchema: WalletScheme,
        validateOnChange: false,
        onSubmit: (values, formikHelpers) => {
            formikHelpers.setSubmitting(true)

            editCommissionUser({
                user_id: reqId,
                commission: values.commission,
            })
                .then(() => {
                    toast.success('Successfully changed')
                    dispatch(
                        setDialogs({
                            key: EDIT_WALLET,
                            value: false,
                        })
                    )
                    changeWallet(values.commission)
                })
                .catch((e) => {
                    toast.error(e?.message || 'Unexpected error')
                })
                .finally(() => {
                    formikHelpers.setSubmitting(false)
                })
        },
    })
    useEffect(() => {
        formik.setValues({
            ...formik.values,
            commission: commission,
        })
    }, [commission])
    return (
        <Dialog
            title={'Edit Commission'}
            onClose={() =>
                dispatch(setDialogs({ key: EDIT_WALLET, value: false }))
            }
            body={
                <div className={style.editWallet}>
                    <form
                        className={style.editWallet__form}
                        onSubmit={(e) => formik.handleSubmit(e)}
                    >
                        <CInput
                            error={formik.errors.commission}
                            name={'commission'}
                            type={'text'}
                            value={formik.values.commission}
                            onChange={formik.handleChange}
                            label={'Commission'}
                            placeholder={''}
                        />
                        <div className={style.editWallet__form__error}>
                            <CButton
                                value={'Edit'}
                                disabled={formik.isSubmitting}
                                type={'submit'}
                                variant={'general'}
                            />
                        </div>
                    </form>
                </div>
            }
        />
    )
}
